<template>
	<div
		:class="[
			'el-check-icon',
			isValid ? '-valid' : '-not-valid'
		]"
	>
		<div
		:class="[
			isValid ? '-tick' : '-cross'
		]"
		>
		</div>
	</div>
</template>

<script>

export default {
	name: 'ElCheckIcon',
	props: {
		isValid: {
			type: Boolean,
			description: 'If `true`, show green checked.',
			default: false
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/sass/variables";

	.el-check-icon {
		content:"\00a0";
		border: $icon-border-size solid $color-accent-valid;
		//opacity: .8;
		border-radius: 50%;
		height: 40px;
		width: 40px;
		display: block;
		position: relative;

		animation: fade-in .5s;

		@keyframes fade-in {
			0% {
				opacity: 0;
			}
			100% {
				opacity: 1;
			}
		}

		.-tick {
				height: 20px;
				width: 10px;
				border: solid $color-accent-valid;
				border-width: 0px $icon-border-size $icon-border-size 0px;
				transform: rotate(45deg) translateX(-100%) translateY(-50%);
				display: block;
				position: absolute;
				top: 55%;
				left: 40%;
			}
		.-cross {
			position: relative;
			left: 49%;
			top: 16%;
			&:before, &:after {
				position: absolute;
				left: 0;
				top: 0;
				content: ' ';
				height: 25px;
				width: $icon-border-size;
				background-color: $color-accent-invalid;
			}
			&:before {
				transform: rotate(45deg);
			}
			&:after {
				transform: rotate(-45deg);
			}
		}
		&.-not-valid,
		&.-not-valid
		> .tick {
			border-color: $color-accent-invalid;
		}
	}
</style>
